import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNotificationsBellIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M13.025 34q1.491 0 2.543-1.036a3.7 3.7 0 0 0 1.131-2.522H9.301q.08 1.485 1.156 2.522A3.58 3.58 0 0 0 13.025 34M7.036 22.6v-8.594q0-2.485 1.736-4.255T13 7.98t4.228 1.77q1.736 1.77 1.736 4.255v8.595zM2.39 26.33h21.22q.803 0 1.346-.54.544-.538.544-1.333 0-.796-.544-1.326-.543-.53-1.346-.53h-.866v-7.584q0-3.777-2.01-6.909-2.012-3.132-5.621-3.877V2.122q0-.9-.592-1.512Q13.928 0 13.016 0q-.91 0-1.52.61-.609.61-.609 1.512v2.109q-3.61.746-5.62 3.772-2.01 3.027-2.011 6.76V22.6H2.39q-.803 0-1.346.538A1.8 1.8 0 0 0 .5 24.473q0 .796.544 1.326.543.53 1.346.53" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 34" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgNotificationsBellIcon;